import { useQuery } from "@tanstack/react-query";
import { useNow } from "@/sentinel";
import { deskApi } from "@/lib/deskApi";
import { marketWindow, todayET } from "@/lib/marketClock";

// Market hours for polling and data labels, in New York time.
// Uses GET /v1/market/calendar when the backend has it; otherwise a weekday 08:30–16:30 ET window.
export { marketWindow, todayET };

/** The calendar row for a date. A 404 (older backend) resolves to null so callers fall back quietly. */
export function useMarketCalendar(date) {
  return useQuery({
    queryKey: ["market-calendar", date],
    queryFn: () => deskApi.marketCalendar(date),
    enabled: !!date,
    staleTime: 6 * 60 * 60 * 1000,
    retry: false,
  });
}

/**
 * Is `selectedDate` today's session while the market window is open?
 * `live` — LIVE labels; `polling` — refetch checkpoints on an interval.
 */
export function useLiveWindow(selectedDate) {
  const now = useNow(15000);
  const today = todayET(now);
  const { data: calendar } = useMarketCalendar(today);
  const w = marketWindow(calendar || null, now);
  const isToday = !!selectedDate && selectedDate === today;
  return { ...w, isToday, live: isToday && w.open, polling: isToday && w.session, now };
}

/** The desk's refetch interval: ~20 s while the selected session is today's and the window is open, else off. */
export const LIVE_REFETCH_MS = 20000;
